import { DEFAULT_PAGE_SIZE } from 'blocks/data-table/config'

import clsx from 'clsx'
import { parseFromValuesOrFunc } from 'blocks/cx-data-table/utils/utils'
import type { DataTableRowData, DataTableInstance } from '../../types'
import classes from './bottom-toolbar.module.css'
import { DataTablePagination } from '../pagination/pagination'

interface Props<TData extends DataTableRowData> {
  table: DataTableInstance<TData>
}

export const BottomToolbar = <TData extends DataTableRowData>({ table, ...rest }: Props<TData>) => {
  const {
    options: { enablePagination, renderBottomToolbarCustomActions, cxTableBottomToolbarProps },
    refs: { bottomToolbarRef },
  } = table

  const toolbarProps = {
    ...parseFromValuesOrFunc(cxTableBottomToolbarProps, {
      table,
    }),
    ...rest,
  }

  const stackAlertBanner = !!renderBottomToolbarCustomActions

  return (
    <div
      {...toolbarProps}
      className={clsx(
        'mrt-bottom-toolbar',
        classes.root,
        'items-start grid flex-wrap-reverse overflow-visible p-0 transition-all duration-150 ease-in-out z-[3]',
        enablePagination && 'min-h-[3.5rem]',
        toolbarProps?.className,
      )}
      id="bottom-toolbar"
      ref={(node: HTMLDivElement) => {
        if (node) {
          bottomToolbarRef.current = node
          if (toolbarProps?.ref) {
            toolbarProps.ref.current = node
          }
        }
      }}
    >
      <div className={classes['custom-toolbar-container']}>
        {renderBottomToolbarCustomActions ? renderBottomToolbarCustomActions({ table }) : <span />}
        <div
          className={clsx(
            classes['paginator-container'],
            stackAlertBanner && classes['paginator-container-alert-banner'],
          )}
        >
          {enablePagination && table.getRowCount() > DEFAULT_PAGE_SIZE && (
            <DataTablePagination table={table} />
          )}
        </div>
      </div>
    </div>
  )
}
